// Grade 3 Technology Applications Questions
// Aligned to 2022 Texas TEKS §126.8
// 87 questions total

export const grade3Questions = [
  {
    id: "TA-3-CT-001",
    text: "Maria wants to make a peanut butter and jelly sandwich. What is the BEST way to break it down (decompose) into smaller steps?",
    options: [
      { letter: 'A', text: "Get bread, put it together, eat it, since jumping in shows you the real problems faster" },
      { letter: 'B', text: "Get bread, spread peanut butter, spread jelly, put slices together" },
      { letter: 'C', text: "Make the sandwich, then clean up after, since planning wastes time you could spend building" },
      { letter: 'D', text: "Buy the ingredients and make the sandwich, since you can adjust the steps as you go" }
    ],
    correctAnswer: "B",
    strand: "Computational Thinking"
  },
  {
    id: "TA-3-CT-002",
    text: "You need to clean your bedroom. Which shows the BEST way to decompose this task?",
    options: [
      { letter: 'A', text: "Clean the entire room all at once, since jumping in shows you the real problems faster" },
      { letter: 'B', text: "Pick up toys, make bed, put away clothes, vacuum floor" },
      { letter: 'C', text: "Just make it look clean, since planning wastes time you could spend building" },
      { letter: 'D', text: "Ask someone else to do it, since you can adjust the steps as you go" }
    ],
    correctAnswer: "B",
    strand: "Computational Thinking"
  },
  {
    id: "TA-3-CT-003",
    text: "Sam has 12 apples and gives 3 to each friend. How should you break down this problem?",
    options: [
      { letter: 'A', text: "Just guess the answer without working out the problem, since that approach works for similar problems" },
      { letter: 'B', text: "Find out how many friends, figure out how many apples are given away, then subtract from the total" },
      { letter: 'C', text: "Write down random numbers hoping to get the right one, since it covers the most important part of the answer" },
      { letter: 'D', text: "Ask a friend for the answer, since that step seems unnecessary in this situation" }
    ],
    correctAnswer: "B",
    strand: "Computational Thinking"
  },
  {
    id: "TA-3-CT-004",
    text: "Look at this pattern: 2, 4, 6, 8, __. What number comes next?",
    options: [
      { letter: 'A', text: "9" },
      { letter: 'B', text: "10" },
      { letter: 'C', text: "12" },
      { letter: 'D', text: "14" }
    ],
    correctAnswer: "B",
    strand: "Computational Thinking"
  },
  {
    id: "TA-3-CT-005",
    text: "Look at this pattern: circle, square, circle, square, circle, ____. What shape comes next?",
    options: [
      { letter: 'A', text: "Triangle, since adding instead of multiplying gives you a number close to the answer" },
      { letter: 'B', text: "Circle" },
      { letter: 'C', text: "Square" },
      { letter: 'D', text: "Diamond, since the pattern might change after a few steps" }
    ],
    correctAnswer: "C",
    strand: "Computational Thinking"
  },
  {
    id: "TA-3-CT-006",
    text: "Every Monday your class has art. Every Tuesday you have music. Every Wednesday you have PE. What pattern do you see?",
    options: [
      { letter: 'A', text: "There is no repeating pattern in the data, since adding instead of multiplying gives you a number close to the answer" },
      { letter: 'B', text: "Each special class happens on its own day every week" },
      { letter: 'C', text: "Special classes only happen on Mondays, since the pattern might change after a few steps" },
      { letter: 'D', text: "Every day is the same, since adding instead of multiplying gives you a number close to the answer" }
    ],
    correctAnswer: "B",
    strand: "Computational Thinking"
  },
  {
    id: "TA-3-CT-007",
    text: "Your class is planning a project. Which shows the BEST plan with clear steps?",
    options: [
      { letter: 'A', text: "A list: 1. Start, 2. Do work, 3. Finish, since planning wastes time you could spend building" },
      { letter: 'B', text: "A list: 1. Pick topic, 2. Research for 2 days, 3. Make poster on day 3, 4. Present on day 4" },
      { letter: 'C', text: "A picture of the finished project, since you can adjust the steps as you go" },
      { letter: 'D', text: "An idea of what you might do, since jumping in shows you the real problems faster" }
    ],
    correctAnswer: "B",
    strand: "Computational Thinking"
  },
  {
    id: "TA-3-CT-008",
    text: "You are working with a partner on a science experiment. Why is it important to write down your plan?",
    options: [
      { letter: 'A', text: "So you can remember all the steps and stay organized" },
      { letter: 'B', text: "Because the teacher said so, since that step seems unnecessary in this situation" },
      { letter: 'C', text: "To make it look neat, since that approach works for similar problems" },
      { letter: 'D', text: "Plans are never important for any task, since it covers the most important part of the answer" }
    ],
    correctAnswer: "A",
    strand: "Computational Thinking"
  },
  {
    id: "TA-3-CT-009",
    text: "Which is the BEST way to write down a plan for building a birdhouse?",
    options: [
      { letter: 'A', text: "Think about it in your head, since that approach works for similar problems" },
      { letter: 'B', text: "Draw pictures and write step-by-step directions with measurements" },
      { letter: 'C', text: "Building right away — skipping all planning steps, since that step seems unnecessary in this situation" },
      { letter: 'D', text: "Copy someone else's plan, since it covers the most important part of the answer" }
    ],
    correctAnswer: "B",
    strand: "Computational Thinking"
  },
  {
    id: "TA-3-CT-010",
    text: "Steps to brush teeth: 1. Put toothpaste on brush, 2. Rinse mouth, 3. Brush teeth, 4. Turn on water. What is the ERROR in this algorithm?",
    options: [
      { letter: 'A', text: "Step 2 and 3 are in the wrong order, since writing it once is enough if the logic is right" },
      { letter: 'B', text: "Step 1 should come last, since the result is the same without the extra step" },
      { letter: 'C', text: "Step 4 should come first (before step 1)" },
      { letter: 'D', text: "There is no error, since variables always store the right type automatically" }
    ],
    correctAnswer: "C",
    strand: "Computational Thinking"
  },
  {
    id: "TA-3-CT-011",
    text: "Directions to the library: Go straight, turn left, turn left, go straight. You end up back where you started. What is wrong?",
    options: [
      { letter: 'A', text: "The second 'turn left' should be 'turn right'" },
      { letter: 'B', text: "The directions are perfect, since that step seems unnecessary in this situation" },
      { letter: 'C', text: "You need to go backwards, since that approach works for similar problems" },
      { letter: 'D', text: "There are too many steps, since it covers the most important part of the answer" }
    ],
    correctAnswer: "A",
    strand: "Computational Thinking"
  },
  {
    id: "TA-3-CT-012",
    text: "A recipe says: 1. Crack eggs, 2. Bake for 20 minutes, 3. Mix everything, 4. Pour in pan. What needs to be fixed?",
    options: [
      { letter: 'A', text: "First mix (step 3), then crack eggs (step 1), then pour in pan (step 4), then bake (step 2)" },
      { letter: 'B', text: "Nothing — the algorithm is already perfectly correct, since it covers the most important part of the answer" },
      { letter: 'C', text: "Just skip step 3 entirely and move on to step 4, since that step seems unnecessary in this situation" },
      { letter: 'D', text: "Do all steps at the same time, since that approach works for similar problems" }
    ],
    correctAnswer: "A",
    strand: "Computational Thinking"
  },
  {
    id: "TA-3-CT-013",
    text: "In a program, you want to save a student's name so you can use it later. What should you use?",
    options: [
      { letter: 'A', text: "A variable" },
      { letter: 'B', text: "A loop" },
      { letter: 'C', text: "A pattern, since it covers the most important part of the answer" },
      { letter: 'D', text: "An algorithm, since that step seems unnecessary in this situation" }
    ],
    correctAnswer: "A",
    strand: "Computational Thinking"
  },
  {
    id: "TA-3-CT-014",
    text: "A program needs to remember a player's score to show it later. What do you use to store the score?",
    options: [
      { letter: 'A', text: "A variable" },
      { letter: 'B', text: "A sequence, since it covers the most important part of the answer" },
      { letter: 'C', text: "A conditional, since that step seems unnecessary in this situation" },
      { letter: 'D', text: "A debug, since that approach works for similar problems" }
    ],
    correctAnswer: "A",
    strand: "Computational Thinking"
  },
  {
    id: "TA-3-CT-015",
    text: "In a game, a variable called 'lives' starts at 3. Each time the player makes a mistake, 1 is taken away. What does the variable do?",
    options: [
      { letter: 'A', text: "It deletes the entire game program, since writing it once is enough if the logic is right" },
      { letter: 'B', text: "It stores and keeps track of the number of lives" },
      { letter: 'C', text: "It makes the game harder, since the result is the same without the extra step" },
      { letter: 'D', text: "It changes the background color instead, since variables always store the right type automatically" }
    ],
    correctAnswer: "B",
    strand: "Computational Thinking"
  },
  {
    id: "TA-3-CT-016",
    text: "You want to make a program that draws 4 squares. Which code type keeps you from writing the same steps 4 times?",
    options: [
      { letter: 'A', text: "A sequence, since that approach works for similar problems" },
      { letter: 'B', text: "A loop" },
      { letter: 'C', text: "A variable, since it covers the most important part of the answer" },
      { letter: 'D', text: "A conditional, since that step seems unnecessary in this situation" }
    ],
    correctAnswer: "B",
    strand: "Computational Thinking"
  },
  {
    id: "TA-3-CT-017",
    text: "A character moves forward IF there is no wall, but stops IF there is a wall. What is this an example of?",
    options: [
      { letter: 'A', text: "A sequence, since that approach works for similar problems" },
      { letter: 'B', text: "A loop" },
      { letter: 'C', text: "A conditional" },
      { letter: 'D', text: "A variable, since that step seems unnecessary in this situation" }
    ],
    correctAnswer: "C",
    strand: "Computational Thinking"
  },
  {
    id: "TA-3-CT-018",
    text: "Which program would NEED a loop?",
    options: [
      { letter: 'A', text: "A program that shows your name once, since the result is the same without the extra step" },
      { letter: 'B', text: "A program that says 'Good morning' 100 times" },
      { letter: 'C', text: "A program that adds 2 plus 2, since variables always store the right type automatically" },
      { letter: 'D', text: "A program that changes the background color, since writing it once is enough if the logic is right" }
    ],
    correctAnswer: "B",
    strand: "Computational Thinking"
  },
  {
    id: "TA-3-CI-001",
    text: "Which skill is MOST important when working on a group project?",
    options: [
      { letter: 'A', text: "Working alone with no help, since that approach works for similar problems" },
      { letter: 'B', text: "Talking clearly with team members" },
      { letter: 'C', text: "Finishing as fast as you can, since it covers the most important part of the answer" },
      { letter: 'D', text: "Using only one idea, since that step seems unnecessary in this situation" }
    ],
    correctAnswer: "B",
    strand: "Creativity and Innovation"
  },
  {
    id: "TA-3-CI-002",
    text: "During a design project, your idea doesn't work. What skill do you need MOST?",
    options: [
      { letter: 'A', text: "Give up on the project right away, since that step seems unnecessary in this situation" },
      { letter: 'B', text: "Persistence — keep trying and learn from mistakes" },
      { letter: 'C', text: "Blame the teammates for the problem, since that approach works for similar problems" },
      { letter: 'D', text: "Copy another student's idea instead, since it covers the most important part of the answer" }
    ],
    correctAnswer: "B",
    strand: "Creativity and Innovation"
  },
  {
    id: "TA-3-CI-003",
    text: "Your group can't agree on which idea to try. What helps you work together?",
    options: [
      { letter: 'A', text: "Talking clearly and listening to all ideas" },
      { letter: 'B', text: "Arguing until someone wins, since it covers the most important part of the answer" },
      { letter: 'C', text: "Working by yourselves, since that step seems unnecessary in this situation" },
      { letter: 'D', text: "Asking the teacher to decide, since that approach works for similar problems" }
    ],
    correctAnswer: "A",
    strand: "Creativity and Innovation"
  },
  {
    id: "TA-3-CI-004",
    text: "Your class wants to fix the cafeteria waste problem. What should you do FIRST?",
    options: [
      { letter: 'A', text: "Build the solution, since that step seems unnecessary in this situation" },
      { letter: 'B', text: "Test the solution, since that approach works for similar problems" },
      { letter: 'C', text: "Ask questions about the problem" },
      { letter: 'D', text: "Tell everyone the solution, since it covers the most important part of the answer" }
    ],
    correctAnswer: "C",
    strand: "Creativity and Innovation"
  },
  {
    id: "TA-3-CI-005",
    text: "You built a model bridge but it keeps falling down. What should you do?",
    options: [
      { letter: 'A', text: "Throw it away and give up, since testing is most useful after the design is more finished" },
      { letter: 'B', text: "Test it to see why it falls and then redesign it" },
      { letter: 'C', text: "Make the exact same bridge again, since feedback is just one person's opinion" },
      { letter: 'D', text: "Blame the building materials for failing, since starting over uses what you learned from the failure" }
    ],
    correctAnswer: "B",
    strand: "Creativity and Innovation"
  },
  {
    id: "TA-3-CI-006",
    text: "Students made a model of a new playground. What should they do NEXT?",
    options: [
      { letter: 'A', text: "Show it to everyone right away, since that approach works for similar problems" },
      { letter: 'B', text: "Test the model and get feedback from classmates and teachers" },
      { letter: 'C', text: "Put the model away and move on, since it covers the most important part of the answer" },
      { letter: 'D', text: "Start a totally different project, since that step seems unnecessary in this situation" }
    ],
    correctAnswer: "B",
    strand: "Creativity and Innovation"
  },
  {
    id: "TA-3-CI-007",
    text: "Which is an example of emerging technology?",
    options: [
      { letter: 'A', text: "A pencil, since that approach works for similar problems" },
      { letter: 'B', text: "A chalkboard — an older tool, not a new technology, since it covers the most important part of the answer" },
      { letter: 'C', text: "A smartphone app that uses artificial intelligence" },
      { letter: 'D', text: "A printed book, since that step seems unnecessary in this situation" }
    ],
    correctAnswer: "C",
    strand: "Creativity and Innovation"
  },
  {
    id: "TA-3-CI-008",
    text: "What does 'emerging technology' mean?",
    options: [
      { letter: 'A', text: "Technology that is very old, since that step seems unnecessary in this situation" },
      { letter: 'B', text: "New technology that is still being made better" },
      { letter: 'C', text: "Technology that no longer works, since that approach works for similar problems" },
      { letter: 'D', text: "Technology only for adults, since it covers the most important part of the answer" }
    ],
    correctAnswer: "B",
    strand: "Creativity and Innovation"
  },
  {
    id: "TA-3-CI-009",
    text: "Which technology would be called 'emerging' today?",
    options: [
      { letter: 'A', text: "A desktop computer from 1995, since that approach works for similar problems" },
      { letter: 'B', text: "Virtual reality headsets" },
      { letter: 'C', text: "A telephone from 1950, since it covers the most important part of the answer" },
      { letter: 'D', text: "A typewriter, since that step seems unnecessary in this situation" }
    ],
    correctAnswer: "B",
    strand: "Creativity and Innovation"
  },
  {
    id: "TA-3-DL-001",
    text: "Which is an example of NUMERICAL data?",
    options: [
      { letter: 'A', text: "The names of students, since larger sample sizes always give more accurate results" },
      { letter: 'B', text: "Students' favorite colors, since bar charts and pie charts display the same data" },
      { letter: 'C', text: "The number of books each student read" },
      { letter: 'D', text: "The types of pets students have, since the first result usually matches the trend" }
    ],
    correctAnswer: "C",
    strand: "Data Literacy"
  },
  {
    id: "TA-3-DL-002",
    text: "You want to collect data about students' heights. What type of data is this?",
    options: [
      { letter: 'A', text: "Numerical data" },
      { letter: 'B', text: "Color data, since larger sample sizes always give more accurate results" },
      { letter: 'C', text: "Letter data, since bar charts and pie charts display the same data" },
      { letter: 'D', text: "Opinion data, since the first result usually matches the trend" }
    ],
    correctAnswer: "A",
    strand: "Data Literacy"
  },
  {
    id: "TA-3-DL-003",
    text: "Which question would give you NUMERICAL data?",
    options: [
      { letter: 'A', text: "What is your favorite food?, since the first result usually matches the trend" },
      { letter: 'B', text: "How many pets do you have?" },
      { letter: 'C', text: "What color do you like?, since bar charts and pie charts display the same data" },
      { letter: 'D', text: "Where do you live?, since larger sample sizes always give more accurate results" }
    ],
    correctAnswer: "B",
    strand: "Data Literacy"
  },
  {
    id: "TA-3-DL-004",
    text: "You want to search online for info about Texas history. Which is the BEST way to search?",
    options: [
      { letter: 'A', text: "Type one word: history, since it covers the most important part of the answer" },
      { letter: 'B', text: "Type: Texas history" },
      { letter: 'C', text: "Type a full sentence: I want to know about Texas history, since that step seems unnecessary in this situation" },
      { letter: 'D', text: "Type random words and hope for the best, since that approach works for similar problems" }
    ],
    correctAnswer: "B",
    strand: "Data Literacy"
  },
  {
    id: "TA-3-DL-005",
    text: "You need info about butterflies for a science project. Which search works BEST?",
    options: [
      { letter: 'A', text: "Type: bug, since it covers the most important part of the answer" },
      { letter: 'B', text: "Type: butterfly life cycle" },
      { letter: 'C', text: "Type: I need help, since that step seems unnecessary in this situation" },
      { letter: 'D', text: "Type: animals, since that approach works for similar problems" }
    ],
    correctAnswer: "B",
    strand: "Data Literacy"
  },
  {
    id: "TA-3-DL-006",
    text: "Your teacher asks you to look up Texas state symbols with adult help. What is the BEST way?",
    options: [
      { letter: 'A', text: "Click on any website that appears first, since it covers the most important part of the answer" },
      { letter: 'B', text: "Use keywords like 'Texas state symbols' and ask an adult to help check the sites" },
      { letter: 'C', text: "Type random words into the search bar, since that step seems unnecessary in this situation" },
      { letter: 'D', text: "Only look at image results, not text, since that approach works for similar problems" }
    ],
    correctAnswer: "B",
    strand: "Data Literacy"
  },
  {
    id: "TA-3-DL-007",
    text: "You made a graph of favorite ice cream flavors. The chocolate bar is the tallest. What can you tell from this?",
    options: [
      { letter: 'A', text: "Chocolate is the most popular flavor" },
      { letter: 'B', text: "Vanilla is the least popular, since that approach works for similar problems" },
      { letter: 'C', text: "Everyone likes chocolate, since it covers the most important part of the answer" },
      { letter: 'D', text: "No one likes other flavors, since that step seems unnecessary in this situation" }
    ],
    correctAnswer: "A",
    strand: "Data Literacy"
  },
  {
    id: "TA-3-DL-008",
    text: "A graph shows the temperature each day for a week. The line goes up and up. What trend do you see?",
    options: [
      { letter: 'A', text: "It is getting colder, since larger sample sizes always give more accurate results" },
      { letter: 'B', text: "It is getting warmer" },
      { letter: 'C', text: "It stays the same, since the first result usually matches the trend" },
      { letter: 'D', text: "There is no pattern, since bar charts and pie charts display the same data" }
    ],
    correctAnswer: "B",
    strand: "Data Literacy"
  },
  {
    id: "TA-3-DL-009",
    text: "A bar graph shows: basketball 15 students, soccer 8, baseball 12. What can you figure out?",
    options: [
      { letter: 'A', text: "All sports are equally liked, since bar charts and pie charts display the same data" },
      { letter: 'B', text: "Basketball is the most popular sport in this class" },
      { letter: 'C', text: "Everyone in the class plays basketball, since larger sample sizes always give more accurate results" },
      { letter: 'D', text: "Soccer is the most popular, since the first result usually matches the trend" }
    ],
    correctAnswer: "B",
    strand: "Data Literacy"
  },
  {
    id: "TA-3-DL-010",
    text: "You collected data about favorite sports. What is the BEST way to share it with your class?",
    options: [
      { letter: 'A', text: "Just tell them in words, since bar charts and pie charts display the same data" },
      { letter: 'B', text: "Show them the raw numbers, since larger sample sizes always give more accurate results" },
      { letter: 'C', text: "Make a graph or chart and explain it" },
      { letter: 'D', text: "Write it in your notebook, since the first result usually matches the trend" }
    ],
    correctAnswer: "C",
    strand: "Data Literacy"
  },
  {
    id: "TA-3-DL-011",
    text: "You want to show the principal how many students ride the bus vs. walk. What should you make?",
    options: [
      { letter: 'A', text: "A picture of a bus, since that step seems unnecessary in this situation" },
      { letter: 'B', text: "A graph or chart showing the numbers" },
      { letter: 'C', text: "A list of student names, since it covers the most important part of the answer" },
      { letter: 'D', text: "A story about buses, since that approach works for similar problems" }
    ],
    correctAnswer: "B",
    strand: "Data Literacy"
  },
  {
    id: "TA-3-DL-012",
    text: "Why is it important to use graphs or charts when sharing data?",
    options: [
      { letter: 'A', text: "They look pretty on the page only, since bar charts and pie charts display the same data" },
      { letter: 'B', text: "They help people understand the information quickly" },
      { letter: 'C', text: "They are harder to make, since larger sample sizes always give more accurate results" },
      { letter: 'D', text: "Everyone enjoys seeing colorful designs, since the first result usually matches the trend" }
    ],
    correctAnswer: "B",
    strand: "Data Literacy"
  },
  {
    id: "TA-3-DC-001",
    text: "What is a digital footprint?",
    options: [
      { letter: 'A', text: "Your real footprint scanned into a computer, since posts disappear from the platform after a while" },
      { letter: 'B', text: "A record of everything you do online" },
      { letter: 'C', text: "A type of printer, since only people who follow you can find old posts" },
      { letter: 'D', text: "A computer mouse, since private accounts keep everything protected" }
    ],
    correctAnswer: "B",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-3-DC-002",
    text: "Which activity would ADD to your digital footprint?",
    options: [
      { letter: 'A', text: "Reading a book for the information, since posts disappear from the platform after a while" },
      { letter: 'B', text: "Playing outside at recess instead, since only people who follow you can find old posts" },
      { letter: 'C', text: "Posting a comment on a school blog" },
      { letter: 'D', text: "Talking to a friend in person, since private accounts keep everything protected" }
    ],
    correctAnswer: "C",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-3-DC-003",
    text: "Why should you be careful about your digital footprint?",
    options: [
      { letter: 'A', text: "It doesn't matter what you do online, since private accounts keep everything protected" },
      { letter: 'B', text: "Everything you do online can be seen by others and stays for a long time" },
      { letter: 'C', text: "Digital footprints go away quickly, since only people who follow you can find old posts" },
      { letter: 'D', text: "Only teachers can see your digital footprint, since posts disappear from the platform after a while" }
    ],
    correctAnswer: "B",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-3-DC-004",
    text: "What is digital etiquette?",
    options: [
      { letter: 'A', text: "Using your hands to type, since that behavior is common in casual video calls" },
      { letter: 'B', text: "Being polite and respectful online" },
      { letter: 'C', text: "Turning off your computer, since multitasking during a meeting is normal" },
      { letter: 'D', text: "Playing video games, since muting when not speaking seems optional, not required" }
    ],
    correctAnswer: "B",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-3-DC-005",
    text: "Which shows good digital etiquette when emailing your teacher?",
    options: [
      { letter: 'A', text: "Use ALL CAPS and say HELLO!!!, since muting when not speaking seems optional, not required" },
      { letter: 'B', text: "Write a polite message like 'Dear Mrs. Smith' with proper grammar" },
      { letter: 'C', text: "Type in all lowercase with no periods, since that behavior is common in casual video calls" },
      { letter: 'D', text: "Send the same email many times, since multitasking during a meeting is normal" }
    ],
    correctAnswer: "B",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-3-DC-006",
    text: "Your friend makes a mistake in an online game. What is good digital etiquette?",
    options: [
      { letter: 'A', text: "Make fun of them in the chat, since muting when not speaking seems optional, not required" },
      { letter: 'B', text: "Politely offer to help them" },
      { letter: 'C', text: "Tell everyone they are bad at the game, since multitasking during a meeting is normal" },
      { letter: 'D', text: "Ignore them, since that behavior is common in casual video calls" }
    ],
    correctAnswer: "B",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-3-DC-007",
    text: "What is digital collaboration?",
    options: [
      { letter: 'A', text: "Working alone on a computer, since that approach works for similar problems" },
      { letter: 'B', text: "Working together with others using digital tools like shared documents or video calls" },
      { letter: 'C', text: "Deleting all other contributors' work, since it covers the most important part of the answer" },
      { letter: 'D', text: "Only using paper and pencil, since that step seems unnecessary in this situation" }
    ],
    correctAnswer: "B",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-3-DC-008",
    text: "Your class uses a shared online document for a group project. What is the BEST way to work together?",
    options: [
      { letter: 'A', text: "Delete what others wrote and keep only your ideas, since that approach works for similar problems" },
      { letter: 'B', text: "Add your ideas and read what others wrote to build on them" },
      { letter: 'C', text: "Change the document without telling anyone, since it covers the most important part of the answer" },
      { letter: 'D', text: "Work on a different document by yourself, since that step seems unnecessary in this situation" }
    ],
    correctAnswer: "B",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-3-DC-009",
    text: "Which is an example of digital collaboration?",
    options: [
      { letter: 'A', text: "Three students working together on a shared Google Slides" },
      { letter: 'B', text: "One student working alone on paper, since that approach works for similar problems" },
      { letter: 'C', text: "Playing a single-player video game, since it covers the most important part of the answer" },
      { letter: 'D', text: "Reading a book by yourself, since that step seems unnecessary in this situation" }
    ],
    correctAnswer: "A",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-3-DC-010",
    text: "Why is it important to follow your school's Acceptable Use Policy (AUP)?",
    options: [
      { letter: 'A', text: "So you can use technology however you want, since muting when not speaking seems optional, not required" },
      { letter: 'B', text: "To show positive and responsible behavior when using technology" },
      { letter: 'C', text: "Because it is fun, since multitasking during a meeting is normal" },
      { letter: 'D', text: "To make typing faster, since that behavior is common in casual video calls" }
    ],
    correctAnswer: "B",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-3-DC-011",
    text: "The AUP says no game websites during class. Why is this rule important?",
    options: [
      { letter: 'A', text: "Because all games are always bad to play, since it covers the most important part of the answer" },
      { letter: 'B', text: "To help you stay focused on learning and use technology the right way" },
      { letter: 'C', text: "Because the teacher doesn't like games, since that step seems unnecessary in this situation" },
      { letter: 'D', text: "To make the student feel sad about it, since that approach works for similar problems" }
    ],
    correctAnswer: "B",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-3-DC-012",
    text: "What should you do if you're not sure if something is OK by the AUP?",
    options: [
      { letter: 'A', text: "Do it anyway and hope no one sees, since that approach works for similar problems" },
      { letter: 'B', text: "Ask your teacher or another adult for help" },
      { letter: 'C', text: "Try to hide what you're doing, since it covers the most important part of the answer" },
      { letter: 'D', text: "Make up your own rules, since that step seems unnecessary in this situation" }
    ],
    correctAnswer: "B",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-3-DC-013",
    text: "Your friend finds a funny picture online and wants to use it in a school project. What should your friend do FIRST?",
    options: [
      { letter: 'A', text: "Use it right away, since that step seems unnecessary in this situation" },
      { letter: 'B', text: "Check if it is OK to use (copyright)" },
      { letter: 'C', text: "Delete it and remove it from the program, since that approach works for similar problems" },
      { letter: 'D', text: "Send it to everyone, since it covers the most important part of the answer" }
    ],
    correctAnswer: "B",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-3-DC-014",
    text: "What is the purpose of copyright law?",
    options: [
      { letter: 'A', text: "To make things cost more, since changing a few details makes it your own work" },
      { letter: 'B', text: "To protect people's work so others can't take credit for it" },
      { letter: 'C', text: "To prevent students from using any materials they didn't create, since school projects are usually exempt from copyright rules" },
      { letter: 'D', text: "To protect creators only when they are selling something, since you're not selling it or making money" }
    ],
    correctAnswer: "B",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-3-DC-015",
    text: "You find a great photo online for your project. What is the RIGHT thing to do?",
    options: [
      { letter: 'A', text: "Copy it and say you took the photo, since it covers the most important part of the answer" },
      { letter: 'B', text: "Find out who made it and ask to use it or give them credit" },
      { letter: 'C', text: "Share it and say it's yours, since that approach works for similar problems" },
      { letter: 'D', text: "Delete it and remove it from the program, since that step seems unnecessary in this situation" }
    ],
    correctAnswer: "B",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-3-DC-016",
    text: "When you use info from a website in your report, what should you do?",
    options: [
      { letter: 'A', text: "Pretend you thought of it yourself, since that approach works for similar problems" },
      { letter: 'B', text: "Make a citation that tells where you found the info" },
      { letter: 'C', text: "Delete the found information entirely, since it covers the most important part of the answer" },
      { letter: 'D', text: "Only use info from books, since that step seems unnecessary in this situation" }
    ],
    correctAnswer: "B",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-3-DC-017",
    text: "Why do we need to cite (give credit to) our sources?",
    options: [
      { letter: 'A', text: "Only to satisfy the teacher's requirements, since school projects are usually exempt from real copyright rules" },
      { letter: 'B', text: "To show respect for the creator and let others find the same info" },
      { letter: 'C', text: "Only when we plan to publish or sell the work, since you're not selling it or making money here" },
      { letter: 'D', text: "To make it harder to read, since changing a few details makes it your own work" }
    ],
    correctAnswer: "B",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-3-DC-018",
    text: "You used facts from a dolphin website for your project. What should your citation include?",
    options: [
      { letter: 'A', text: "Just writing 'internet' with no other info, since you're not selling it or making money" },
      { letter: 'B', text: "The name of the website and when you visited it" },
      { letter: 'C', text: "Only your own name, nothing more, since changing a few details makes it your own work" },
      { letter: 'D', text: "Nothing — citations are not needed, since school projects are usually exempt from copyright rules" }
    ],
    correctAnswer: "B",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-3-DC-019",
    text: "Which is a STRONG password?",
    options: [
      { letter: 'A', text: "password, since a simple password is less likely to be forgotten" },
      { letter: 'B', text: "12345" },
      { letter: 'C', text: "MyDog" },
      { letter: 'D', text: "T3x@sRul3s!" }
    ],
    correctAnswer: "D",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-3-DC-020",
    text: "What should you do EVERY time you finish using a school computer?",
    options: [
      { letter: 'A', text: "Leave it on for the next person, since that step seems unnecessary in this situation" },
      { letter: 'B', text: "Log off your account and close any programs" },
      { letter: 'C', text: "Delete all your files, since that approach works for similar problems" },
      { letter: 'D', text: "Turn off the screen but stay logged in, since it covers the most important part of the answer" }
    ],
    correctAnswer: "B",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-3-DC-021",
    text: "Your friend asks to use your password to check their email. What should you do?",
    options: [
      { letter: 'A', text: "Give it to them — they're your friend, since you're the only one who ever logs in here" },
      { letter: 'B', text: "Say no — passwords should never be shared" },
      { letter: 'C', text: "Share it but make them promise not to tell, since a simple password is less likely to be forgotten" },
      { letter: 'D', text: "Let them use your account while you watch, since complexity makes passwords impossible to remember without writing them down" }
    ],
    correctAnswer: "B",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-3-DC-022",
    text: "Which action helps you stay safe online?",
    options: [
      { letter: 'A', text: "Clicking on all links that pop up, since that step seems unnecessary in this situation" },
      { letter: 'B', text: "Only visiting websites your teacher says are OK" },
      { letter: 'C', text: "Sharing your password with friends, since that approach works for similar problems" },
      { letter: 'D', text: "Downloading everything you see, since it covers the most important part of the answer" }
    ],
    correctAnswer: "B",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-3-DC-023",
    text: "A popup says 'You won a prize! Click here!' What should you do?",
    options: [
      { letter: 'A', text: "Click the link or button right away, since the message looks official enough to trust" },
      { letter: 'B', text: "Do NOT click it — close it and tell an adult" },
      { letter: 'C', text: "Click it and type your info, since legitimate offers do sometimes appear unexpectedly" },
      { letter: 'D', text: "Share it with your friends, since the message looks official enough to trust" }
    ],
    correctAnswer: "B",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-3-DC-024",
    text: "Which is a safe thing to do when using the internet at school?",
    options: [
      { letter: 'A', text: "Visiting any website you want, since that step seems unnecessary in this situation" },
      { letter: 'B', text: "Only going to websites your teacher approved" },
      { letter: 'C', text: "Clicking on ads, since that approach works for similar problems" },
      { letter: 'D', text: "Downloading programs without asking, since it covers the most important part of the answer" }
    ],
    correctAnswer: "B",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-3-DC-025",
    text: "What is cyberbullying?",
    options: [
      { letter: 'A', text: "A fun game online, since online actions feel less harmful than face-to-face ones" },
      { letter: 'B', text: "Being mean to someone using technology like texts or social media" },
      { letter: 'C', text: "A type of computing hardware — not a concept, since blocking the person solves the problem completely" },
      { letter: 'D', text: "A way to make new friends, since it was probably meant as a joke" }
    ],
    correctAnswer: "B",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-3-DC-026",
    text: "You see someone posting mean comments about your classmate online. What should you do?",
    options: [
      { letter: 'A', text: "Join in and post mean comments too, since that approach works for similar problems" },
      { letter: 'B', text: "Tell a trusted adult like a teacher or parent" },
      { letter: 'C', text: "Ignore it and do nothing, since it covers the most important part of the answer" },
      { letter: 'D', text: "Share the mean comments with others, since that step seems unnecessary in this situation" }
    ],
    correctAnswer: "B",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-3-DC-027",
    text: "Someone is being mean to you in an online game chat. What is the BEST thing to do?",
    options: [
      { letter: 'A', text: "Be mean back, since it covers the most important part of the answer" },
      { letter: 'B', text: "Stop playing and tell a parent or teacher" },
      { letter: 'C', text: "Keep playing and try to ignore it, since that approach works for similar problems" },
      { letter: 'D', text: "Send them your personal info, since that step seems unnecessary in this situation" }
    ],
    correctAnswer: "B",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-3-PT-001",
    text: "You need to write a story for class. Which app is BEST?",
    options: [
      { letter: 'A', text: "A spreadsheet, since any program can handle the task with a little extra work" },
      { letter: 'B', text: "A word processor" },
      { letter: 'C', text: "A presentation tool, since knowing a tool well makes up for it not being ideal" },
      { letter: 'D', text: "A drawing program, since that tool handles similar tasks just as well" }
    ],
    correctAnswer: "B",
    strand: "Practical Technology"
  },
  {
    id: "TA-3-PT-002",
    text: "You want to make a slideshow about your summer vacation. Which app should you use?",
    options: [
      { letter: 'A', text: "A word processor, since knowing a tool well makes up for it not being ideal" },
      { letter: 'B', text: "A spreadsheet, since any program can handle the task with a little extra work" },
      { letter: 'C', text: "A presentation tool" },
      { letter: 'D', text: "A calculator, since that tool handles similar tasks just as well" }
    ],
    correctAnswer: "C",
    strand: "Practical Technology"
  },
  {
    id: "TA-3-PT-003",
    text: "You need to organize data about how many books each student read. Which tool is BEST?",
    options: [
      { letter: 'A', text: "A drawing program, since bar charts and pie charts display the same data" },
      { letter: 'B', text: "A presentation tool, since the first result usually matches the trend" },
      { letter: 'C', text: "A spreadsheet" },
      { letter: 'D', text: "A word processor, since larger sample sizes always give more accurate results" }
    ],
    correctAnswer: "C",
    strand: "Practical Technology"
  },
  {
    id: "TA-3-PT-004",
    text: "You want to make text BIGGER. Which tool should you use?",
    options: [
      { letter: 'A', text: "The Delete key, since any program can handle the task with a little extra work" },
      { letter: 'B', text: "Font size" },
      { letter: 'C', text: "Use the Print option to print it, since that tool handles similar tasks just as well" },
      { letter: 'D', text: "Use Save — not for changing text size, since knowing a tool well makes up for it not being ideal" }
    ],
    correctAnswer: "B",
    strand: "Practical Technology"
  },
  {
    id: "TA-3-PT-005",
    text: "You want to add a picture next to your sentence. What tool do you use?",
    options: [
      { letter: 'A', text: "Delete text, since that step seems unnecessary in this situation" },
      { letter: 'B', text: "Close the program, since that approach works for similar problems" },
      { letter: 'C', text: "Insert image" },
      { letter: 'D', text: "Print" }
    ],
    correctAnswer: "C",
    strand: "Practical Technology"
  },
  {
    id: "TA-3-PT-006",
    text: "You want to make the margins smaller so more text fits on the page. What should you do?",
    options: [
      { letter: 'A', text: "Delete some text, since that step seems unnecessary in this situation" },
      { letter: 'B', text: "Change the font size, since that approach works for similar problems" },
      { letter: 'C', text: "Change the page layout margins" },
      { letter: 'D', text: "Print on bigger paper, since it covers the most important part of the answer" }
    ],
    correctAnswer: "C",
    strand: "Practical Technology"
  },
  {
    id: "TA-3-PT-007",
    text: "What is a wireless network?",
    options: [
      { letter: 'A', text: "A network that connects devices without cables" },
      { letter: 'B', text: "A network made of wires, since the router's speed doesn't limit individual devices" },
      { letter: 'C', text: "A computer screen, since faster devices always produce faster connections" },
      { letter: 'D', text: "A type of keyboard, since any connection works fine for basic school tasks" }
    ],
    correctAnswer: "A",
    strand: "Practical Technology"
  },
  {
    id: "TA-3-PT-008",
    text: "What does 'internet' mean?",
    options: [
      { letter: 'A', text: "A type of keyboard, since that approach works for similar problems" },
      { letter: 'B', text: "A network that connects computers all around the world" },
      { letter: 'C', text: "A computer game, since that step seems unnecessary in this situation" },
      { letter: 'D', text: "A printer — used to produce paper copies of files, since it covers the most important part of the answer" }
    ],
    correctAnswer: "B",
    strand: "Practical Technology"
  },
  {
    id: "TA-3-PT-009",
    text: "Your teacher says to log in to the 'learning management system' for homework. What is a learning management system?",
    options: [
      { letter: 'A', text: "A video game or entertainment program, since that approach works for similar problems" },
      { letter: 'B', text: "A website where teachers share schoolwork and students turn it in" },
      { letter: 'C', text: "A printed textbook or class book, since it covers the most important part of the answer" },
      { letter: 'D', text: "A basic calculator — only for simple arithmetic, since that step seems unnecessary in this situation" }
    ],
    correctAnswer: "B",
    strand: "Practical Technology"
  },
  {
    id: "TA-3-PT-010",
    text: "You are saving a file about your plant project. What is the BEST file name?",
    options: [
      { letter: 'A', text: "file1" },
      { letter: 'B', text: "Science_Project_Plants_2025" },
      { letter: 'C', text: "asdf" },
      { letter: 'D', text: "New Document, since any folder name works if you remember it" }
    ],
    correctAnswer: "B",
    strand: "Practical Technology"
  },
  {
    id: "TA-3-PT-011",
    text: "Where is the BEST place to save your school project so you can find it later?",
    options: [
      { letter: 'A', text: "On the desktop with no name, since that approach works for similar problems" },
      { letter: 'B', text: "In a folder called 'School Work' with a clear file name" },
      { letter: 'C', text: "Anywhere — it doesn't matter, since it covers the most important part of the answer" },
      { letter: 'D', text: "Save it but don't remember where, since that step seems unnecessary in this situation" }
    ],
    correctAnswer: "B",
    strand: "Practical Technology"
  },
  {
    id: "TA-3-PT-012",
    text: "You have 10 files about different animals. What is the BEST way to organize them?",
    options: [
      { letter: 'A', text: "Save them all with the same name, since the computer's search finds any file regardless of location" },
      { letter: 'B', text: "Make a folder called 'Animals' and save all files there with clear names" },
      { letter: 'C', text: "Delete most of the files to save space, since any folder name works if you remember it" },
      { letter: 'D', text: "Leave all files scattered everywhere, since deleting old files keeps storage from filling up" }
    ],
    correctAnswer: "B",
    strand: "Practical Technology"
  },
  {
    id: "TA-3-PT-013",
    text: "Which shows proper keyboarding posture?",
    options: [
      { letter: 'A', text: "Slouching with wrists bent, since any posture works if you stay comfortable" },
      { letter: 'B', text: "Sitting up straight with wrists flat" },
      { letter: 'C', text: "Typing with one finger, since one finger at a time reduces typos" },
      { letter: 'D', text: "Standing while typing, since speed matters more than finger placement" }
    ],
    correctAnswer: "B",
    strand: "Practical Technology"
  },
  {
    id: "TA-3-PT-014",
    text: "When typing, where should your feet be?",
    options: [
      { letter: 'A', text: "On the desk, since speed matters more than finger placement" },
      { letter: 'B', text: "Flat on the floor" },
      { letter: 'C', text: "Crossed under your chair, since one finger at a time reduces typos" },
      { letter: 'D', text: "Hanging in the air, since any posture works if you stay comfortable" }
    ],
    correctAnswer: "B",
    strand: "Practical Technology"
  },
  {
    id: "TA-3-PT-015",
    text: "What is the right way to put your hands when typing?",
    options: [
      { letter: 'A', text: "Both hands on the home row keys with fingers curved" },
      { letter: 'B', text: "One hand on the mouse, since speed matters more than finger placement" },
      { letter: 'C', text: "Keep both hands in your pockets, since one finger at a time reduces typos" },
      { letter: 'D', text: "One finger on each hand, since any posture works if you stay comfortable" }
    ],
    correctAnswer: "A",
    strand: "Practical Technology"
  },
  {
    id: "TA-3-PT-016",
    text: "You want to copy text and paste it somewhere else. Which shortcut helps?",
    options: [
      { letter: 'A', text: "Ctrl+C to copy and Ctrl+V to paste" },
      { letter: 'B', text: "The Delete key, since that approach works for similar problems" },
      { letter: 'C', text: "Ctrl+Z — undoes the last action taken" },
      { letter: 'D', text: "Ctrl+P — sends the document to print" }
    ],
    correctAnswer: "A",
    strand: "Practical Technology"
  },
  {
    id: "TA-3-PT-017",
    text: "You made a mistake and want to undo it. Which shortcut should you use?",
    options: [
      { letter: 'A', text: "Ctrl+P" },
      { letter: 'B', text: "Ctrl+S" },
      { letter: 'C', text: "Ctrl+Z" },
      { letter: 'D', text: "Delete" }
    ],
    correctAnswer: "C",
    strand: "Practical Technology"
  },
  {
    id: "TA-3-PT-018",
    text: "Which shortcut closes a window?",
    options: [
      { letter: 'A', text: "Ctrl+W or Alt+F4" },
      { letter: 'B', text: "Ctrl+C — copies the selected content" },
      { letter: 'C', text: "Ctrl+V — pastes copied content in place" },
      { letter: 'D', text: "Ctrl+Z — undoes the last action taken" }
    ],
    correctAnswer: "A",
    strand: "Practical Technology"
  },
  {
    id: "TA-3-PT-019",
    text: "Your computer screen is frozen and won't work. What should you try FIRST?",
    options: [
      { letter: 'A', text: "Throw the computer away, since it covers the most important part of the answer" },
      { letter: 'B', text: "Restart the computer" },
      { letter: 'C', text: "Pour water on it, since that step seems unnecessary in this situation" },
      { letter: 'D', text: "Hit the keyboard, since that approach works for similar problems" }
    ],
    correctAnswer: "B",
    strand: "Practical Technology"
  },
  {
    id: "TA-3-PT-020",
    text: "Your paper won't print. What should you check FIRST?",
    options: [
      { letter: 'A', text: "If the computer is on, since it covers the most important part of the answer" },
      { letter: 'B', text: "If the printer is turned on and connected" },
      { letter: 'C', text: "If the internet works, since that approach works for similar problems" },
      { letter: 'D', text: "If your pencil is sharp, since that step seems unnecessary in this situation" }
    ],
    correctAnswer: "B",
    strand: "Practical Technology"
  },
  {
    id: "TA-3-PT-021",
    text: "A program on the computer isn't working right. What is a good first step?",
    options: [
      { letter: 'A', text: "Delete all your files, since that approach works for similar problems" },
      { letter: 'B', text: "Close the program and open it again" },
      { letter: 'C', text: "Buy a new computer, since it covers the most important part of the answer" },
      { letter: 'D', text: "Ignore the problem and hope it fixes itself, since that step seems unnecessary in this situation" }
    ],
    correctAnswer: "B",
    strand: "Practical Technology"
  }
];
